/**
 * Small monochrome line icons for the sidebar nav (24x24 grid, 1.75 stroke,
 * drawn in currentColor so they follow the link's text colour in both themes
 * and the active-link highlight). Inline SVG - no icon library needed.
 */
const PATHS = {
  dashboard: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /><path d="M10 20v-6h4v6" /></>,
  apInvoice: <><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5" /><path d="M12 11v7" /><path d="M9.5 15.5L12 18l2.5-2.5" /></>,
  arInvoice: <><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5" /><path d="M12 18v-7" /><path d="M9.5 13.5L12 11l2.5 2.5" /></>,
  timesheet: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></>,
  payments: <><rect x="3" y="6" width="18" height="12" rx="2" /><circle cx="12" cy="12" r="2.5" /><path d="M6.5 9.5v5M17.5 9.5v5" /></>,
  remittance: <><rect x="3" y="5.5" width="18" height="13" rx="1.5" /><path d="M3.5 6.5l8.5 6.5 8.5-6.5" /><path d="M14.5 16l1.8 1.8 3.2-3.3" /></>,
  purchaseOrder: <><rect x="5" y="4" width="14" height="17" rx="1.5" /><path d="M9 4V3h6v1" /><path d="M8.5 10h7M8.5 13.5h7M8.5 17h4" /></>,
  workOrder: <><rect x="3.5" y="7" width="17" height="12.5" rx="1.5" /><path d="M9 7V5h6v2" /><path d="M3.5 12.5h17" /></>,
  client: <><path d="M4 21V8l8-4 8 4v13" /><path d="M9 21v-5h6v5" /><path d="M8.5 11h1M14.5 11h1" /></>,
  vendor: <><path d="M3 9l1.5-5h15L21 9" /><path d="M3 9h18v2a3 3 0 01-6 0 3 3 0 01-6 0 3 3 0 01-6 0z" /><path d="M5 13v7h14v-7" /></>,
  contractor: <><circle cx="12" cy="8" r="3.5" /><path d="M5 20a7 7 0 0114 0" /></>,
  people: <><circle cx="9" cy="8.5" r="3" /><path d="M3.5 19a5.5 5.5 0 0111 0" /><circle cx="16.5" cy="9.5" r="2.5" /><path d="M15.5 14.2A4.5 4.5 0 0120.5 19" /></>,
  expenses: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" /><path d="M9 8h6M9 12h6M9 16h3" /></>,
  bank: <><path d="M3 9.5L12 4l9 5.5" /><path d="M4 21h16" /><path d="M6 10.5V18M10 10.5V18M14 10.5V18M18 10.5V18" /></>,
  ledger: <><path d="M5 4h11a3 3 0 013 3v14H8a3 3 0 01-3-3z" /><path d="M5 18a3 3 0 013-3h11" /><path d="M9 8h6" /></>,
  aging: <><path d="M4 20V10M10 20V6M16 20v-8" /><path d="M3 20h18" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 2.5v3M12 18.5v3M4.2 6.2l2.1 2.1M17.7 15.7l2.1 2.1M2.5 12h3M18.5 12h3M4.2 17.8l2.1-2.1M17.7 8.3l2.1-2.1" /></>,
  audit: <><circle cx="11" cy="11" r="6.5" /><path d="M20.5 20.5l-4.9-4.9" /><path d="M11 8v3l2 1.5" /></>,
  help: <><circle cx="12" cy="12" r="8.5" /><path d="M9.5 9.5a2.5 2.5 0 114 2c-.9.6-1.5 1.1-1.5 2.2" /><path d="M12 16.8v.2" /></>,
};

export default function NavIcon({ name, size = 18 }) {
  const paths = PATHS[name];
  if (!paths) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      {paths}
    </svg>
  );
}
